export enum Medication {
  semaglutide = "semaglutide",
  metformin = "metformin",
  tirzepatide = "tirzepatide",
  ozempic = "ozempic",
  zepbound = "zepbound",
}

export enum ConsultType {
  scheduled_video_visit = "scheduled_video_visit",
  async_messaging = "async_messaging",
  followup_video_visit = "followup_video_visit",
  chart_review = "chart_review",
  async_lab_order = "async_lab_order",
  chart_addendum = "chart_addendum",
  prior_authorization = "prior_authorization",
  initial_async = "initial_async",
}

export enum ConsultReason {
  initial = "initial",
  follow_up = "follow_up",
  side_effect = "side_effect",
  lab_result = "lab_result",
  missed_sla = "Other - Missed SLA",
}

export enum VisitType {
  refill = "refill",
  sideEffect = "sideEffect",
  followUp = "followUp",
  initial = "initial",
  chartAddendum = "chart_addendum",
  other = "other",
}

export enum Miscs {
  mealPlanSetup = "mealPlanSetup",
  firstCheckin = "firstCheckin", // "initialCheckin",
}

export enum MealLabels {
  breakfast = "Breakfast",
  lunch = "Lunch",
  dinner = "Dinner",
  snack = "Snack",
}

export enum CardBrands {
  amex = "amex",
  discover = "discover",
  mastercard = "mastercard",
  visa = "visa",
}

export enum TreatmentPlanState {
  TreatmentPlan = "treatmentPlan",
  RefillCheckIn = "refillCheckIn",
  ContinueCheckIn = "continueCheckIn",
  CheckInReview = "checkInReview",
  SideEffects = "sideEffects",
  MessageFromProvider = "messageFromProvider",
  AppointmentRequired = "appointmentRequired",
  LabsRequired = "labsRequired",
  AdditionalSetupRequired = "additionalSetupRequired",
  /** Indicates user has a canceled appointment and needs to reschedule */
  RescheduleRequired = "rescheduleRequired",
  CareUpdate = "careUpdate",
}

export enum TreatmentPlanStateOL {
  AdditionalSetupRequired = "additionalSetupRequired",
  AppointmentConfirmed = "appointmentConfirmed",
}

// TODO - clean up when semaglutide ff is removed
export enum MembershipPrice {
  monthly = 129,
  oneTime = 99,
  nutritionProgram = 39,
  programOriginalPrice = 645,
  nutritionProgramOriginalPrice = 78,
  discount = 30,
}

export enum MembershipPriceSB {
  monthly = 299,
  oneTime = 229, // monthly - discount
  nutritionProgram = 39,
  nutritionProgramOriginalPrice = 78,
  programPrice = 207.67, // monthly - pharmacyCoverage
  discount = 70,
  pharmacyCoverage = 91.33,
}

export enum MembershipMonthlyPrice {
  monthly = 299,
  monthlyOriginalPrice = 375,
  discount = 75,
}

export enum AffirmPrice {
  asLowAsPrice = 166.5,
  asLowAsPrice3Months = 111.38,
  asLowAsPrice4Months = 149,
  brandedMedsMonthly = 999,
  brandedMeds6Months = 999 * 6,
  brandedMeds3Months = 999 * 3,
  brandedMeds4Months = 2796,
  semaSixMonths = MembershipPriceSB.oneTime * 6,
}

export enum ZepboundPrice {
  asLowAsPrice4Months = 149,
  bundle4Months = 2796,
  firstMonthPromoPrice = 100,
  month1offerPrice = 49,
  monthly = 499,
  originalPrice = 699,
  rebillLillyDirectOfferPrice = 299,
}

export enum WegovyPrice {
  monthly = 278,
  originalPrice = 1299,
  asLowAsPrice4Months = 149,
  pen = 199,
  bundle4Months = 2796,
  consultationPrice = 166,
  pharmacyPrice = 30,
  month1offerPrice = 49,
  firstMonthPromoPrice = 100,
}

export enum WegovyPillPrice {
  med = 149,
  membership = 49,
  membershipDiscount = 100,
  pharmacyPrice = 30,
  monthly = 198,
}

export enum OzempicPrice {
  monthly = 299,
  originalPrice = 499,
}

export enum CheckoutRoutes {
  Approval = "/approval",
  Results = "/results",
  Address = "/address",
  Payment = "/payment",
  AffirmPayment = "/affirm-payment",
  /**
   * The screen is gone (FLEX-360), but `/account` remains the post-purchase
   * return handler (`PostPurchaseReturn`): it exchanges `firebase_token`,
   * preserves the other query parameters, and routes to Glide onboarding or
   * the Ionic flow. It survives because `getRedirectUrl()` still puts
   * `/account` into the `return_url` of the JWT that the SMS recovery offer
   * and the results router hand to checkout. Retire the constant and the
   * redirect in `App.tsx` together, once that `return_url` is repointed.
   */
  Account = "/account",
}

export enum AffirmTransactionStatus {
  Succeeded = "succeeded",
  RequiresAction = "requires_action",
  Failed = "requires_payment_method",
}

export enum PriorAuthStatus {
  Pending = "PENDING",
  Denied = "DENIED",
  Approved = "APPROVED",
}

export enum platform {
  FuturhealthPlus = "futurhealth_plus",
  Legacy = "futurhealth_legacy",
}

export enum MSO {
  openloop = "openloop",
  steadymd = "steadymd",
  carevalidate = "carevalidate",
}

export enum AppEntrypoint {
  legacy_mobile = "legacy_mobile",
  fh_plus_web = "fh_plus_web",
  fh_plus_mobile = "fh_plus_mobile",
}

export enum SmsSmartRecoveryRoutes {
  Offer = "/offer/rt-sms-sr",
}
